import React, { Component } from "react";
import { DialogTitle, DialogActions, Button, TextField } from "@material-ui/core";
import { ColGrid } from "js/react/components/LayoutGrid";
import {
    BeautifulDialog,
    DialogContent
} from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import CheckBox from "js/react/components/CheckBox";
import linkDS from "js/react/views/PresentationSettings/dataservices/LinkDataService";
import { trackActivity } from "js/core/utilities/utilities";
import { ToggleAllowCommenting } from "../components/ToggleAllowCommenting";
import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";
import getLogger from "js/core/logger";
import { ShowSnackBar } from "js/react/components/Dialogs/SnackBar";

const logger = getLogger();

export default class CreateEmbedCodeDialog extends Component {
    static get type() {
        return "EmbedCode";
    }

    constructor() {
        super();
        this.state = {
            useCustomSize: false,
            width: 640,
            height: 360,
            accepted: false,
            fetching: true,
            allowCommenting: false,
        };
        this.embedRef = React.createRef();
    }

    handleAccept = () => {
        const embedOptions = {
            width: this.state.width,
            height: this.state.height,
            useCustomSize: this.state.useCustomSize
        };
        const allowCommenting = this.state.allowCommenting;
        linkDS.updateLink(this.link, {
            embedOptions,
            allowCommenting,
        });
        linkDS.saveLink(this.props.presentation, this.link).then(() => {
            this.copyToClipboard();
            ShowSnackBar({
                message: "Embed code was copied to the clipboard"
            });
            this.setState({ accepted: true });
            this.props.closeDialog();
            const props = {
                presentation_id: this.props.presentation.id,
                link_ids: [this.link.get("id")],
                is_new: true,
                type: "embed_code",
                workspace_id: this.props.presentation.getWorkspaceId()
            };
            trackActivity("Sharing", "CopyLink", null, null, props, { audit: true });
            this.props.callback();
        });
    };

    componentDidMount() {
        linkDS.createEmbedLink(this.props.presentation)
            .then(link => {
                this.link = link;
                this.setState({ fetching: false });
            })
            .catch(err => {
                logger.error(err, "linkDS.createEmbedLink() failed", { presentationId: this.props.presentation.id });
            });
    }

    componentWillUnmount() {
        if (!this.state.accepted && this.link) {
            this.link.destroy();
        }
    }

    copyToClipboard() {
        const embedCode = this.props.presentation.getEmbedCode(this.link, this.state);
        clipboardWrite(
            {
                [ClipboardType.HTML]: embedCode,
                [ClipboardType.TEXT]: embedCode,
            },
            true,
        );
    }

    handleCustomSize(value, type) {
        if (type == "width") {
            this.setState({
                width: value,
                height: value * 0.5625
            });
        } else {
            this.setState({
                height: value,
                width: value * 1.7777777778
            });
        }
    }

    toggleAllowCommenting = event => {
        const allowCommenting = !this.state.allowCommenting;
        this.setState({ allowCommenting });
        this.forceUpdate();
    }

    render() {
        const { fetching, allowCommenting } = this.state;

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog}>
                <DialogTitle>Create Embed Code</DialogTitle>
                <DialogContent className="dialog-embed">
                    <h3>
                        Creates and copies a snippet of html code you can use to embed this presentation into a website or blog.
                        Pro users can track engagement with comments and viewer analytics.
                    </h3>
                    <Gap10 />
                    <ToggleAllowCommenting
                        allowCommenting={allowCommenting}
                        onToggle={this.toggleAllowCommenting}
                    />
                    <ColGrid>
                        <CheckBox
                            checked={this.state.useCustomSize}
                            value="useCustomSize"
                            label="Use Custom Size"
                            onChange={value =>
                                this.setState({ useCustomSize: value })
                            }
                        />
                        {this.state.useCustomSize &&
                            <>
                                <TextField
                                    id="width"
                                    label="Width"
                                    placeholder="auto"
                                    value={this.state.width}
                                    type="number"
                                    className="textField"
                                    onChange={event =>
                                        this.handleCustomSize(event.target.value, "width")
                                    }
                                />
                                <TextField
                                    id="height"
                                    label="Height"
                                    placeholder="auto"
                                    value={this.state.height}
                                    type="number"
                                    className="textField"
                                    onChange={event =>
                                        this.handleCustomSize(event.target.value, "height")
                                    }
                                />
                            </>
                        }
                    </ColGrid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeDialog}>Cancel</Button>
                    <Button onClick={this.handleAccept} disabled={fetching} color="primary">
                        Copy Embed Code to Clipboard
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
